export default "__VITE_ASSET__d2a6a3e6__"